import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  PdvEvidencijaPojedinacnaDto,
  PdvEvidencijeClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PdvEvidencijaPojedinacnaResolver
  extends BaseService
  implements Resolve<PdvEvidencijaPojedinacnaDto> {
  constructor(private _client: PdvEvidencijeClient) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<PdvEvidencijaPojedinacnaDto>
    | Promise<PdvEvidencijaPojedinacnaDto>
    | PdvEvidencijaPojedinacnaDto
    | null {
    const id = Number.parseInt(route.paramMap.get('id') ?? '');
    return this._client.getPdvEvidencijaPojedinacna(id).pipe(
      map((x) => x.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
